(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ui/bank/assets/javascripts/shared.js') >= 0) return;  svs.modules.push('/components/ui/bank/assets/javascripts/shared.js'); "use strict";


var svs = svs || {};

(function (svs) {
  'use strict';

  var isServerSide = typeof exports === 'object',
      config;

  if (isServerSide) {
    const trinidad = require('trinidad-core').core;

    config = trinidad.config;
  } else {
    config = {
      options: svs.core.config.data.svsconfig
    };
  }

  svs.ui = svs.ui || {};
  svs.ui.bank = svs.ui.bank || {};
  const path = '/images/ui/bank/',
        hashedFiles = {
    'bankgirot': 'bankgirot-284-66f80d387e26a446d712ba926c9e10fe56c0dc26.png',
    'bankgirot-24': 'bankgirot-24-4c160e2091b714de724997ee6b447aef7769ac5a.png',
    'bankgirot-36': 'bankgirot-36-b8dbeebe280e4595ba6657dde687cf4b2b6c7857.png',
    'bankgirot-48': 'bankgirot-48-7e1640a3e4998c1886706fa6453a54e34da06f1d.png',
    'bankgirot-96': 'bankgirot-96-8326097afd819c716946e8073ff31e0870d08460.png',
    'bankgirot-142': 'bankgirot-142-d361220c3bfd5c8363aea26cc8b30a6fac323877.png',
    'bankgirot-72': 'bankgirot-72-609d1ee60d9453dad1a86b1580edb70464599ec1.png',
    'bankgirot-192': 'bankgirot-192-a0be57dff9ab0fc02710d6dbabe32941c28f2a7b.png',
    'bankgirot-284': 'bankgirot-284-66f80d387e26a446d712ba926c9e10fe56c0dc26.png',
    'bankid-neg': 'bankid-neg-284-6373ce6e89da8af2c6bb24801793603e86dd678c.png',
    'bankid-neg-24': 'bankid-neg-24-32d9f4d2b053d97cd199ce6dc406cc6fe98ae35f.png',
    'bankid-neg-36': 'bankid-neg-36-2d60a7e9ffb155b2d9ed0edeeb8c142f70753e1e.png',
    'bankid-neg-48': 'bankid-neg-48-f8598ae9e4c20afe818f52e5450e67171fe08406.png',
    'bankid-neg-96': 'bankid-neg-96-0e6ab7bdf8b73737475374fa570296f32112812a.png',
    'bankid-neg-142': 'bankid-neg-142-88ae6095ff9cdd59593efbd18fe43c33d433e125.png',
    'bankid-neg-72': 'bankid-neg-72-c4ac2d7663fd7e4dffdbdeb559db8632c4be5ada.png',
    'bankid-neg-192': 'bankid-neg-192-d5c6a70da1fd2619d3860989d77f39ebc90c62b7.png',
    'bankid-neg-284': 'bankid-neg-284-6373ce6e89da8af2c6bb24801793603e86dd678c.png',
    'bankid-promo': 'bankid-promo-284-17c52120c84ff1e1c97f0789e5fd2b7264db0d82.png',
    'bankid-promo-24': 'bankid-promo-24-105b267d68f987d6829edcbc016c061830181777.png',
    'bankid-promo-36': 'bankid-promo-36-5d4e5ea397cbf038f82e9523de2e8d46d0f9b4eb.png',
    'bankid-promo-48': 'bankid-promo-48-56aa38eeaecacbf1bf2ac6bb248a470eb470862a.png',
    'bankid-promo-96': 'bankid-promo-96-703f92c6941e5307e1d797459cdcb7da70742569.png',
    'bankid-promo-142': 'bankid-promo-142-2707772f08a4f50bc4b8acd43dfd4be34b5615cf.png',
    'bankid-promo-72': 'bankid-promo-72-c794a44d8a00b6f9146c0348cdc29f561aa0facd.png',
    'bankid-promo-192': 'bankid-promo-192-361f608b750e7ab9563e801f49c44aea97f697fa.png',
    'bankid-promo-284': 'bankid-promo-284-17c52120c84ff1e1c97f0789e5fd2b7264db0d82.png',
    'freja-eid-neg': 'freja-eid-neg-284-96babbb3bead9d40fb334c66958cc8b8e487eb8a.png',
    'freja-eid-neg-24': 'freja-eid-neg-24-e64480b665aec448aae307b08e2b6fe16512089e.png',
    'freja-eid-neg-36': 'freja-eid-neg-36-a5f0cef2a88ff1bcd07ff2db48f4763428a0c6d3.png',
    'freja-eid-neg-48': 'freja-eid-neg-48-b078cb171232739b76220f3e41ecf08b7f199758.png',
    'freja-eid-neg-96': 'freja-eid-neg-96-81abf34b8464cd62a5b1d809313fce49e23c5162.png',
    'freja-eid-neg-142': 'freja-eid-neg-142-3700b1e4065074cdae0a9cdcccd6d6882cbfdd94.png',
    'freja-eid-neg-72': 'freja-eid-neg-72-06181a7c86c886fcf79abc78ac428e131e906cf7.png',
    'freja-eid-neg-192': 'freja-eid-neg-192-2b2d8b66493ca7681029339417e206f1ea5a024a.png',
    'freja-eid-neg-284': 'freja-eid-neg-284-96babbb3bead9d40fb334c66958cc8b8e487eb8a.png',
    'freja-eid-vertical-neg': 'freja-eid-vertical-neg-284-347e6db9e0068e2406b6181751111096f8a153cd.png',
    'freja-eid-vertical-neg-24': 'freja-eid-vertical-neg-24-1acb25bb515f431e0de10c4edb23ebf1278255f0.png',
    'freja-eid-vertical-neg-36': 'freja-eid-vertical-neg-36-2a5949fe58dc4613376bbc90bbca5976a682f170.png',
    'freja-eid-vertical-neg-48': 'freja-eid-vertical-neg-48-905a222ffd3a22b9b79e47a11c337ddc70b78c49.png',
    'freja-eid-vertical-neg-96': 'freja-eid-vertical-neg-96-647fdc5f2282b608a40e94ef76b9e63c0ada4fa5.png',
    'freja-eid-vertical-neg-142': 'freja-eid-vertical-neg-142-a682f5df05bbb8973d8f091bfbe4ef429629af2f.png',
    'freja-eid-vertical-neg-72': 'freja-eid-vertical-neg-72-e2f701928fa35763e4d10842f3b2fd935db137e6.png',
    'freja-eid-vertical-neg-192': 'freja-eid-vertical-neg-192-540c1c98add030276fb6ff959ce62ef59e29099c.png',
    'freja-eid-vertical-neg-284': 'freja-eid-vertical-neg-284-347e6db9e0068e2406b6181751111096f8a153cd.png',
    'freja-eid-vertical': 'freja-eid-vertical-284-3d59d5d907ed7c6741322f41c224d33f5c24ee4d.png',
    'freja-eid-vertical-24': 'freja-eid-vertical-24-90ba887de687e547bd28c871bf26596a80bb1cd5.png',
    'freja-eid-vertical-36': 'freja-eid-vertical-36-6bfa61111f3a8d1c3c0522570288f93c0b8a4129.png',
    'freja-eid-vertical-48': 'freja-eid-vertical-48-96aba4d92e5605d44f48c858238473d5a2f0cb89.png',
    'freja-eid-vertical-96': 'freja-eid-vertical-96-753ed68742ce297e9db38a0345ea319ac88b5d2c.png',
    'freja-eid-vertical-142': 'freja-eid-vertical-142-bf358b1b7bd2b5a3a568349ac2c7a0886c606498.png',
    'freja-eid-vertical-72': 'freja-eid-vertical-72-31a662c727b0ad52d812673d95c478a32b4b2053.png',
    'freja-eid-vertical-192': 'freja-eid-vertical-192-a191886c3a91425d38b2c961f92060f1f4136870.png',
    'freja-eid-vertical-284': 'freja-eid-vertical-284-3d59d5d907ed7c6741322f41c224d33f5c24ee4d.png',
    'freja-eid': 'freja-eid-284-8befe495b29f019d93e6b9fbb77569abb7f6641f.png',
    'freja-eid-24': 'freja-eid-24-4a3b16a7b653f92a94426416c6d8dd845614a58e.png',
    'freja-eid-36': 'freja-eid-36-49843c68ce9fbfe24547eff3a4e70495bb07dc3e.png',
    'freja-eid-48': 'freja-eid-48-a2e98f1af5f48bd7c1c6c55adfe1949b4b1b6ae1.png',
    'freja-eid-96': 'freja-eid-96-80a23ae9ea949953bc42aca3af4df44be0fc1b24.png',
    'freja-eid-142': 'freja-eid-142-0f36c08634d47ff7e21f081eb2e97479fe458086.png',
    'freja-eid-72': 'freja-eid-72-fb147a10ae6300eb7e0893797b24870351eb04b0.png',
    'freja-eid-192': 'freja-eid-192-ea6fe4a3c636786208c136f1e73521c208e4a5fd.png',
    'freja-eid-284': 'freja-eid-284-8befe495b29f019d93e6b9fbb77569abb7f6641f.png',
    'handelsbanken': 'handelsbanken-284-c4ee014c294c340b0fbf337261626a696372d06e.png',
    'handelsbanken-24': 'handelsbanken-24-7ec1ff9f6b7c67180052b5a2809c2a478e882a07.png',
    'handelsbanken-36': 'handelsbanken-36-7229721d017a67de8f8bbad5ccd9b201d11e2e48.png',
    'handelsbanken-48': 'handelsbanken-48-6de5aedc0f3441df9707b39a0b519e9f0d3e3283.png',
    'handelsbanken-96': 'handelsbanken-96-1190098175f529347ee46ecb8ecc6e773e5870db.png',
    'handelsbanken-142': 'handelsbanken-142-de59209771f2130305c4af7ac902f9b038d2f1c0.png',
    'handelsbanken-72': 'handelsbanken-72-e2beadb1a2ce277ebaa863832487153be538145e.png',
    'handelsbanken-192': 'handelsbanken-192-5b978285c0ee52f105bccc49dc33c4ca0907dd3d.png',
    'handelsbanken-284': 'handelsbanken-284-c4ee014c294c340b0fbf337261626a696372d06e.png',
    'mastercard': 'mastercard-284-79446ca56a220260551e611c49ea6045824fafe8.png',
    'mastercard-24': 'mastercard-24-1313d74fa4a331c9289a590166e36d7fb7bbea46.png',
    'mastercard-36': 'mastercard-36-a7710713ddf6c8a4d8b4e921c2319f5b1994245f.png',
    'mastercard-48': 'mastercard-48-3946630e241547d41fc37c3f95754e769609dc5b.png',
    'mastercard-96': 'mastercard-96-2590d49b520231a692601d398b47db23bccd16d2.png',
    'mastercard-142': 'mastercard-142-815ce19d252138a4179fbcfe2690e2731e8ca519.png',
    'mastercard-72': 'mastercard-72-34336d085025bf700a5d9d08767b2a25c9027e62.png',
    'mastercard-192': 'mastercard-192-d5642b25450756f6f47699bb655c9042a5a00fcf.png',
    'mastercard-284': 'mastercard-284-79446ca56a220260551e611c49ea6045824fafe8.png',
    'mastercardsecurecode': 'mastercardsecurecode-284-6ae9ad422c6529c63615431f78257b21df459124.png',
    'mastercardsecurecode-24': 'mastercardsecurecode-24-e4f99eb0c6b483e79dcd09b13a9e8abc3056ad22.png',
    'mastercardsecurecode-36': 'mastercardsecurecode-36-1e7a24c2c4169b161395ab735c51e0ef06f8b945.png',
    'mastercardsecurecode-48': 'mastercardsecurecode-48-801d8ecb350098af98ae5ba2c5cdcf5698db0533.png',
    'mastercardsecurecode-96': 'mastercardsecurecode-96-9b089efdf50832d2ef63fd64d58fffaaf6429c0a.png',
    'mastercardsecurecode-142': 'mastercardsecurecode-142-3251358d904bdf346156e045171c43f7cc7e6dbc.png',
    'mastercardsecurecode-72': 'mastercardsecurecode-72-f7507e5e1c659e8994f7ff84649a1bc2dae796e0.png',
    'mastercardsecurecode-192': 'mastercardsecurecode-192-8c93e8bab3870497cf00293d0d5b68e82d8accc9.png',
    'mastercardsecurecode-284': 'mastercardsecurecode-284-6ae9ad422c6529c63615431f78257b21df459124.png',
    'masterpass-neg': 'masterpass-neg-284-9c3508d7db8ad50eacc2ee3c8b6c36c3501efa4c.png',
    'masterpass-neg-24': 'masterpass-neg-24-4d9790e2158401a1a21fefa2d9fc00b15e9140c5.png',
    'masterpass-neg-36': 'masterpass-neg-36-5eadedd45894ac7728aaee07e1295564d5d09e7a.png',
    'masterpass-neg-48': 'masterpass-neg-48-c18de32f3f43ae5c346c82ee3a898326e0123d89.png',
    'masterpass-neg-96': 'masterpass-neg-96-9f9c026990d8a4d532b502e19a877c05a874530d.png',
    'masterpass-neg-142': 'masterpass-neg-142-663df02c1c08ca608ae2a9c16b8a8a848115a004.png',
    'masterpass-neg-72': 'masterpass-neg-72-eeb53f8b960bd41dc3899f41b0a6b8dedcf36000.png',
    'masterpass-neg-192': 'masterpass-neg-192-4ba15d9bd2222fa3a0b3b1189398245475dc72cd.png',
    'masterpass-neg-284': 'masterpass-neg-284-9c3508d7db8ad50eacc2ee3c8b6c36c3501efa4c.png',
    'masterpass-promo': 'masterpass-promo-284-4b59444b941083b658743294a5773250c921ec81.png',
    'masterpass-promo-24': 'masterpass-promo-24-c63abe90edff8b3e0c878ef8e102630749e9eb71.png',
    'masterpass-promo-36': 'masterpass-promo-36-65d03c9f2d80073927f49c328421a4e7d6c83af5.png',
    'masterpass-promo-48': 'masterpass-promo-48-ec0c72f7c0b2c739c80468f3382c89c79c3c301a.png',
    'masterpass-promo-96': 'masterpass-promo-96-2997cc518d3fbc0968afca656627247741930d11.png',
    'masterpass-promo-142': 'masterpass-promo-142-3518aa7f7280b907cc02970c316bd37522876d65.png',
    'masterpass-promo-72': 'masterpass-promo-72-2556fc47d8155d1d6aa737da3aaaeaef5d0fe1e0.png',
    'masterpass-promo-192': 'masterpass-promo-192-2ffae2fcd42b7fd9a304525f8a31234d8b93e4f0.png',
    'masterpass-promo-284': 'masterpass-promo-284-4b59444b941083b658743294a5773250c921ec81.png',
    'masterpass': 'masterpass-284-63ad1869eba201ac149df138d47e663e06b7468b.png',
    'masterpass-24': 'masterpass-24-a0fe0e41628b58144ce02a0ef3a7bab7934885bf.png',
    'masterpass-36': 'masterpass-36-bace805e50c10d7ce6440fd67ba2a44b0ed66d37.png',
    'masterpass-48': 'masterpass-48-e4c2cef8546b278d124747f7eb1925e27a276095.png',
    'masterpass-96': 'masterpass-96-64b74fded2f7008bdb9a2c984a2c06eb71377838.png',
    'masterpass-142': 'masterpass-142-050f6f3163ff8a77bc0aa27249e797131a3574f1.png',
    'masterpass-72': 'masterpass-72-8229b32bba5775719cecf3a09b189721f026a424.png',
    'masterpass-192': 'masterpass-192-e8e9499415895225065da016364265eb782c3546.png',
    'masterpass-284': 'masterpass-284-63ad1869eba201ac149df138d47e663e06b7468b.png',
    'nordea': 'nordea-284-a687046fdf1fb6f2c64746bd20224af8b3c5838a.png',
    'nordea-24': 'nordea-24-760f39922c013bb3ecb8e4575a0a882d87316fb1.png',
    'nordea-36': 'nordea-36-bc460777d054f93f7d81e743b49967141df0d31b.png',
    'nordea-48': 'nordea-48-835c5a1743f295463d472de40d4bf875c06311ad.png',
    'nordea-96': 'nordea-96-bd4681e34522dac3ca39ff7c64552a32bfeb9f91.png',
    'nordea-142': 'nordea-142-6afb43d4cf0f06be2b2c518ea28bb06b26e21ce1.png',
    'nordea-72': 'nordea-72-951fe96a36088c69d99d04be2e3c39cb171bf7d3.png',
    'nordea-192': 'nordea-192-6043cba06745366eaf3abcca5b7ee279a335a848.png',
    'nordea-284': 'nordea-284-a687046fdf1fb6f2c64746bd20224af8b3c5838a.png',
    'payex-grey': 'payex-grey-284-ca95da450eb4054752f682e8b91fa54bdbc5bec1.png',
    'payex-grey-24': 'payex-grey-24-2fd78708f041ecdbdae6a61b27f71308bc4d3c9d.png',
    'payex-grey-36': 'payex-grey-36-49648b06480e1a94ab19c67875903336260979f7.png',
    'payex-grey-48': 'payex-grey-48-7cc936c05dcb023623a753836c2f0fb04cec5206.png',
    'payex-grey-96': 'payex-grey-96-3e278fb5c4e878e856d9b54a31b3d83912576051.png',
    'payex-grey-142': 'payex-grey-142-74495fb56c4496f58cd3d78703528a64eedc28be.png',
    'payex-grey-72': 'payex-grey-72-946818983b769b5af4bec883102917cb08da9e11.png',
    'payex-grey-192': 'payex-grey-192-c4dd5847cf80cf4c90fd915fa22016b1740890d0.png',
    'payex-grey-284': 'payex-grey-284-ca95da450eb4054752f682e8b91fa54bdbc5bec1.png',
    'payex': 'payex-284-88b2d3ab99327446c1b33e259974dd0a00552038.png',
    'payex-24': 'payex-24-2f86516e0114b1534651372e608fba7a7d186e4e.png',
    'payex-36': 'payex-36-ad35e3562159509a8c0bfddd42b78eea86b76ddf.png',
    'payex-48': 'payex-48-a779733bbfb1d86877f7ad6f05e84a8cccb7fe56.png',
    'payex-96': 'payex-96-8b8e3f5fb336ef87fabc9793cbb03d5bfcd12fd0.png',
    'payex-142': 'payex-142-5e7bcd3c2e58cd0f53743abc4d6cbc3c0ee1c475.png',
    'payex-72': 'payex-72-93939c21dda432719001561090a45155bc9c3309.png',
    'payex-192': 'payex-192-18bc9bfd442bf796326b7348a8bcc11a92b92bdb.png',
    'payex-284': 'payex-284-88b2d3ab99327446c1b33e259974dd0a00552038.png',
    'seb': 'seb-284-8f8c6a8395faf96d1ed3e27ed7723be2d48089a8.png',
    'seb-24': 'seb-24-60524f17fd89eed0450a69c1ce030e3393d13f74.png',
    'seb-36': 'seb-36-5b6a5de14c3a1cee20f20a33abee37237ceba043.png',
    'seb-48': 'seb-48-943a58b415a59f23fbd5bc99a16679ef783356be.png',
    'seb-96': 'seb-96-1812daa2bab5579d2a934f4daeb0483dec2edc65.png',
    'seb-142': 'seb-142-46f92d81a86e541931bc116ba52c2126efc11d85.png',
    'seb-72': 'seb-72-816b5b15f000521069d7e58445f6f96a9afd0a2c.png',
    'seb-192': 'seb-192-7c0751959cfb3bf6fe33a82dfa6d50c7ce41636b.png',
    'seb-284': 'seb-284-8f8c6a8395faf96d1ed3e27ed7723be2d48089a8.png',
    'swedbank': 'swedbank-284-7f16b5b7bcb3bf4a626179de7e1a9b2e0f000a96.png',
    'swedbank-24': 'swedbank-24-45859429a815c98b18dc633d7ae3e62133b41cb0.png',
    'swedbank-36': 'swedbank-36-56ec1e9944a1d06a36761d952280bd99d52c6914.png',
    'swedbank-48': 'swedbank-48-862f97cf2705ba9c94015e685bf6ae0acbc988f0.png',
    'swedbank-96': 'swedbank-96-a802c410cf55289bb1c8656faf9eb7d2b3e69aac.png',
    'swedbank-142': 'swedbank-142-2cf593eb6aabe0cf2e88209ccf4882e52832326d.png',
    'swedbank-72': 'swedbank-72-f0461c71b6f1643e71eb2cc897b15e9568efd082.png',
    'swedbank-192': 'swedbank-192-b8bb034032d046a6891ccbf94c405a01df42bf9a.png',
    'swedbank-284': 'swedbank-284-7f16b5b7bcb3bf4a626179de7e1a9b2e0f000a96.png',
    'swedbankpay-neg': 'swedbankpay-neg-284-4a44f6a815d150c1928a6826382efe8f86bb2c3a.png',
    'swedbankpay-neg-24': 'swedbankpay-neg-24-cc38bd5339f8be71e77459c02b0ed9a4d2ded7ff.png',
    'swedbankpay-neg-36': 'swedbankpay-neg-36-ad82f6c35acbf406eb2f3ccd7bc335f7d83eca83.png',
    'swedbankpay-neg-48': 'swedbankpay-neg-48-5af4142085ae50f9a021cacccbbba78792500dac.png',
    'swedbankpay-neg-96': 'swedbankpay-neg-96-a5ec2c876d2821d26fa63c4e06644479d68ab729.png',
    'swedbankpay-neg-142': 'swedbankpay-neg-142-de70a0ee7cb8ce0a8f3e9b9511c98971b0dde964.png',
    'swedbankpay-neg-72': 'swedbankpay-neg-72-2fab0b81edba67651c7d424c38c0a76144a426f2.png',
    'swedbankpay-neg-192': 'swedbankpay-neg-192-9e037e3f11c260a60613111711b1f30639dec79e.png',
    'swedbankpay-neg-284': 'swedbankpay-neg-284-4a44f6a815d150c1928a6826382efe8f86bb2c3a.png',
    'swedbankpay': 'swedbankpay-284-d5c4a48070e4d243d1f4ca361e7318829e036548.png',
    'swedbankpay-24': 'swedbankpay-24-81d8550ffe40dfb1f366d65db2a5a7a8332c36a9.png',
    'swedbankpay-36': 'swedbankpay-36-45c53db67b0e1201ffd3aa07d7ffe535b09efaa4.png',
    'swedbankpay-48': 'swedbankpay-48-4d240708b692dff2c0ed43cc3740676cc6380dff.png',
    'swedbankpay-96': 'swedbankpay-96-b42c9cc60135dd2999b1c40a870958b781773464.png',
    'swedbankpay-142': 'swedbankpay-142-ec4af241698fd9da6362c85e677f0aa28af19ee9.png',
    'swedbankpay-72': 'swedbankpay-72-dc5da8379c76ff13f7abacb840b28c5ba89cfdcf.png',
    'swedbankpay-192': 'swedbankpay-192-7145019ebb21605703df5fd1aa2b009b8ceaedb3.png',
    'swedbankpay-284': 'swedbankpay-284-d5c4a48070e4d243d1f4ca361e7318829e036548.png',
    'swish-grey': 'swish-grey-284-d395707c6e605fa4a8a9c519414dce636ccfc0c9.png',
    'swish-grey-24': 'swish-grey-24-e7790148731aa347f71f55f2b2c0775e51aac13c.png',
    'swish-grey-36': 'swish-grey-36-f51d5cf8b42d379f8f1d0f7c1d5d6fd496012ab1.png',
    'swish-grey-48': 'swish-grey-48-7df5485a8eec9bcd6a594f5ed458e46a49f9b79e.png',
    'swish-grey-96': 'swish-grey-96-90a424566320ef559e513d7225fab940c2fbad7f.png',
    'swish-grey-142': 'swish-grey-142-83fe67a17a38af7617e12063150d22123151b581.png',
    'swish-grey-72': 'swish-grey-72-c3bc2a2fb9e3305af3214710f9b2d252186acf53.png',
    'swish-grey-192': 'swish-grey-192-48354dd0119f601e813a387c96f35ede5f67ecc0.png',
    'swish-grey-284': 'swish-grey-284-d395707c6e605fa4a8a9c519414dce636ccfc0c9.png',
    'swish-neg': 'swish-neg-284-583b3a43e2815f6c3af13514b663e3de0c3ac14f.png',
    'swish-neg-24': 'swish-neg-24-4308a1012e742ec40091a67a42c7364b1ce107b2.png',
    'swish-neg-36': 'swish-neg-36-1c2c1faf993902e8d8ce7e77fc5fec9cfe5a244d.png',
    'swish-neg-48': 'swish-neg-48-f30fc7e99297d98717409cbd77b95aa05cee4baa.png',
    'swish-neg-96': 'swish-neg-96-ed32f81068f0c1fd46e6d6a3a603daf3d9abeaa4.png',
    'swish-neg-142': 'swish-neg-142-5d2fd46f1721c95ef0afe992a6334138aaa7d910.png',
    'swish-neg-72': 'swish-neg-72-484d006b997848ea4a298f95391bc8d5ffbc20ab.png',
    'swish-neg-192': 'swish-neg-192-9caee56de65a99b2b59396ce42e1c982716890c9.png',
    'swish-neg-284': 'swish-neg-284-583b3a43e2815f6c3af13514b663e3de0c3ac14f.png',
    'swish-promo': 'swish-promo-284-f1145f0db44fe40b339514471a51a1dd68668b19.png',
    'swish-promo-24': 'swish-promo-24-0bf5bb2cd1b4fa1767eb8d30a80627a485145280.png',
    'swish-promo-36': 'swish-promo-36-fa357e0a9464c73f32389ac161b8070fbd59919b.png',
    'swish-promo-48': 'swish-promo-48-9953c21cb0c3ba1455163113262876ec3a08f22b.png',
    'swish-promo-96': 'swish-promo-96-798fe0ffcb3c7e462efacb18caebef4a488ade94.png',
    'swish-promo-142': 'swish-promo-142-20572013af5a5ef80398fa88f2ef6a97e10bda09.png',
    'swish-promo-72': 'swish-promo-72-32fa8a96c824e8335d6eb52159b112e438bf37f9.png',
    'swish-promo-192': 'swish-promo-192-f503ea88035e1a84a61b36c708828c5c6221cd4e.png',
    'swish-promo-284': 'swish-promo-284-f1145f0db44fe40b339514471a51a1dd68668b19.png',
    'swish': 'swish-284-0ae82b2fdb0c1bda53e95ebfdd3b49570ab67039.png',
    'swish-24': 'swish-24-7815034cd0bd8324da539eface6b457047b2509d.png',
    'swish-36': 'swish-36-2cdc81648ba86717011287b1ea56a800785a97fc.png',
    'swish-48': 'swish-48-f29b1cd9120ef48b2aaa2febc1946572f1b58c72.png',
    'swish-96': 'swish-96-1274ec9e27d207a2f650d3070424c0f033972181.png',
    'swish-142': 'swish-142-64b6cd2356d1f2940b3f66bac5de967bdac655a0.png',
    'swish-72': 'swish-72-62e06c945b352e8df44bdb0221e3bfa796ec5237.png',
    'swish-192': 'swish-192-8edb1c951085a96e138b4ebd095bf3a234977178.png',
    'swish-284': 'swish-284-0ae82b2fdb0c1bda53e95ebfdd3b49570ab67039.png',
    'verifiedbyvisa': 'verifiedbyvisa-284-0ccfe895660763089a310acf2a2b792873523505.png',
    'verifiedbyvisa-24': 'verifiedbyvisa-24-095a311f6f05df17d12cba38a7152061c6ed40ec.png',
    'verifiedbyvisa-36': 'verifiedbyvisa-36-c28514bf9a61c6c1c66c30806455038a461de8a6.png',
    'verifiedbyvisa-48': 'verifiedbyvisa-48-f68361fa05fac2a1ae233be87fcc6f2e1353d343.png',
    'verifiedbyvisa-96': 'verifiedbyvisa-96-f594753e0bf877c83f764bea340a54b53ae9b3f0.png',
    'verifiedbyvisa-142': 'verifiedbyvisa-142-89ecac659d888bedf3a48792c95c294c6aa6531a.png',
    'verifiedbyvisa-72': 'verifiedbyvisa-72-4c999182e3e7afee8631ecf58ac01694da981cd4.png',
    'verifiedbyvisa-192': 'verifiedbyvisa-192-24342b8dca046c5e84bf5c4be528b3aece7c8189.png',
    'verifiedbyvisa-284': 'verifiedbyvisa-284-0ccfe895660763089a310acf2a2b792873523505.png',
    'visa': 'visa-284-3924bccf8ebb8cfa923820bec85a48738eed367b.png',
    'visa-24': 'visa-24-408df507ba198090082627279943919d4fe09880.png',
    'visa-36': 'visa-36-9615ffa9375c7682e6cf8b0579efe26630869382.png',
    'visa-48': 'visa-48-6f833995f0f873641308558b0d69d14cbfcaba95.png',
    'visa-96': 'visa-96-d47aea7b8bfa1fb3da9412d8445b9783988faf7e.png',
    'visa-142': 'visa-142-c54132a9ff09192a3f602347dec8e1b3cdc99ecc.png',
    'visa-72': 'visa-72-8d3fde4f88253b9e80054f9a9bf76253ba99736a.png',
    'visa-192': 'visa-192-0afce8e4def87c0cefdaddffcf3eb104ba66a424.png',
    'visa-284': 'visa-284-3924bccf8ebb8cfa923820bec85a48738eed367b.png'
  };

  svs.ui.bank.getIMG = function (file, size) {
    let hashedStr,
        hashedStrRetina,
        cdn = config.options && config.options.cdn ? config.options.cdn : '',
        ret = {};

    if (hashedFiles[file] && size > 0) {
      hashedStr = hashedFiles[file + '-' + size] ? file + '-' + size : file;
      hashedStrRetina = hashedFiles[file + '-' + size * 2] ? file + '-' + size * 2 : file;
    }

    if (hashedFiles[hashedStr]) {
      ret = [cdn + path + hashedFiles[hashedStr], cdn + path + hashedFiles[hashedStrRetina]];
    }

    return ret;
  }; 


  if (isServerSide) {
    module.exports = svs.ui.bank;
  }
})(svs);
 })(window);